import { withFormik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import { ScheduleLockForm } from '../../components/Agenda/ScheduleLock';

export const ScheduleLockContainer = (props) => {
    return (
        <ScheduleLockFormik
            initialValues={props.initialValues}
            onSubmit={props.onSubmit}
            onCancel={props.onClose}
        />
    );
}
ScheduleLockContainer.propTypes = {
    initialValues: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

const ScheduleLockFormik = withFormik({
    mapPropsToValues: (props) => props.initialValues || {},
    //validationSchema: getAgendaAppointmentSchema(),
    handleSubmit: (values, formikBag) => {
        formikBag.props.onSubmit(values);
    },
    displayName: 'ScheduleLock',
})(ScheduleLockForm);

ScheduleLockFormik.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};